import Account from '@/helper/AccountHelper.js';

const FARMER = 1;  // 0001
const SALE = 2;       // 0010
const SUBDIST = 4;       // 0100
const DIST = 8;         // 1000

export function UserLevel() {
    this.userLevel = Account.getUserLevel();

    this.isFarmer = function () {
        let rs = this.userLevel & FARMER;
        return rs != 0
    };

    this.isSale = function () {
        let rs = this.userLevel & SALE;
        return rs != 0;
    };

    this.isSubdist = function () {
        let rs = this.userLevel & SUBDIST;
        return rs != 0;
    };

    this.isDist = function () {
        let rs = this.userLevel & DIST;
        return rs != 0;
    };
}
